// extracted by mini-css-extract-plugin
export var avatarButton = "header-module--avatarButton--b7953";
export var logo = "header-module--logo--cbdef";
export var profile = "header-module--profile--607d0";
export var profileAvatar = "header-module--profileAvatar--200e7";
export var profileIcon = "header-module--profileIcon--6ce12";
export var profileName = "header-module--profileName--ca443";
export var profileNav = "header-module--profileNav--45d62";
export var profileToggle = "header-module--profileToggle--55eca";
export var root = "header-module--root--b78d4";
export var search = "header-module--search--830a2";